import { Typography } from "antd";
import { TextProps } from "antd/es/typography/Text";
import React from "react";
import { memo } from "react";

const { Text: AntText } = Typography;

interface props extends TextProps {
  type?: "danger" | "secondary" | "success" | "warning";
  children?: React.ReactNode;
}

const Text = memo<props>(({ type, children, ...rest }) => {
  return <AntText {...{ type }} {...rest}>{children}</AntText>;
});

export { Text };
